// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"98":"schdNews","362":"brand","626":"gsdtNews","697":"news","702":"xpkxNews","836":"Antifake","893":"products","894":"services"}[chunkId] + "." + {"98":"fe835b99","362":"68c7501f","626":"372c5406","697":"725a742a","702":"af7648ca","836":"105c653c","893":"9629dfbb","894":"c238a081"}[chunkId] + ".css";
};